/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-reached': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="#6ca2ca"><path pid="0" d="M8.17 11.814c-4.705.305-8.164 1.864-8.164 3.994 0 2.377 4.442 4.064 9.882 4.064 5.441 0 9.882-1.687 9.882-4.064 0-1.673-2.157-2.997-5.448-3.65a.5.5 0 1 0-.195.981c2.862.568 4.643 1.66 4.643 2.67 0 1.56-3.958 3.063-8.882 3.063-4.923 0-8.882-1.504-8.882-3.064 0-1.365 3.014-2.723 7.23-2.996a.5.5 0 1 0-.065-.998z"/><path pid="1" d="M8.703 15.69V.5a.5.5 0 0 0-1 0v15.19a.5.5 0 1 0 1 0z"/><path pid="2" d="M16.343 5.589c-1.659 1.799-5.328 2.43-7.952 1.367a.5.5 0 1 0-.376.926c3.42 1.386 8.318.279 9.781-2.645a.5.5 0 0 0-.507-.72c-2.452.294-3.482-.267-4.87-2.035l-.195-.25C10.961.618 10.074.001 8.321.001a.5.5 0 1 0 0 1c1.374 0 2.023.452 3.116 1.848l.196.25c1.372 1.75 2.566 2.533 4.71 2.49z"/></g>'
  }
})
